module.exports = __webpack_public_path__ + "static/img/MH.2a8a5194.png";